import { Injectable } from "@angular/core"
import { Observable, from } from "rxjs"
import { Dexie, Table } from "dexie"
import { tap } from "rxjs/operators"

export interface SingleResource {
    id?: number
    resourceSlug: string
}

export interface MediaGallery {
    id?: number
    mediaGallerySlug: string
}

@Injectable({
    providedIn: "root",
})
export class IndexedDBService extends Dexie {
    mediaGalleries!: Table<MediaGallery, number>
    singleResources!: Table<SingleResource, number>

    constructor() {
        super("ngdexieliveQuery")
        //Important: when new table is added in version list, @this.version should be increased by 1!
        this.version(6).stores({
            mediaGalleries: "++id",
            singleResources: "++id",
        })
    }

    getDataForSingleResources(): Observable<unknown> {
        if (!this.singleResources) throw new Error("Single Resources table is not initialized.")
        return from(this.singleResources.toArray())
    }

    getDataForMediaGalleries(): Observable<unknown> {
        if (!this.mediaGalleries) throw new Error("Media Galleries table is not initialized.")
        return from(this.mediaGalleries.toArray())
    }

    excludeCautionFlagsForResource(mediaType: string, slug: string): Observable<number> {
        if (mediaType === "Media Gallery") {
            return this.mediaGalleryPopulate(slug)
        } else return this.singleResourcePopulate(slug)
    }

    private singleResourcePopulate(slug: string): Observable<number> {
        const resourceToAdd: SingleResource[] = [{ resourceSlug: slug }]
        const resourcePopulate: Observable<number> = from(
            this.singleResources.bulkAdd(resourceToAdd)
        )
        return resourcePopulate.pipe(tap((data: number) => console.log(data)))
    }

    private mediaGalleryPopulate(slug: string): Observable<number> {
        const mediaGalleriesToAdd: MediaGallery[] = [{ mediaGallerySlug: slug }]
        const mediaGalleryPopulate$: Observable<number> = from(
            this.mediaGalleries.bulkAdd(mediaGalleriesToAdd)
        )
        return mediaGalleryPopulate$.pipe(tap((data: number) => console.log(data)))
    }
}
